import React from "react";
import { Modal } from "@mui/material";
import styles from "./popup.module.css";
import CustomButton from "../buttons/CustomButton";

const ORLTExcelPopup = ({ open, onClose, handleExportToExcel }) => {
    return (
        <Modal open={open} onClose={onClose}>
            <div className={styles.modalContainer}>
                <div className={styles.dialogBox}>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '20px' }}>
                        <CustomButton
                            label="With RM table"
                            onClick={() => handleExportToExcel(true)}
                            type="reject"
                        />
                        <CustomButton
                            label="Without RM table"
                            onClick={() => handleExportToExcel(false)}
                            type="reject"
                        />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                        <CustomButton
                            label="Close"
                            onClick={onClose}
                            type="reject"
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ORLTExcelPopup;